import {z} from 'zod';
import {ObjectIdSchema} from '../zod';
import {zodTypeguard} from '../api/helpers';
import {CategorySchema} from '../fields/enrichment';
import {CampaignSchema} from '../chatabm';

export const GenerateAgentStateSchema = z.object({
  agentId: ObjectIdSchema.optional(),
});
export type GenerateAgentState = z.infer<typeof GenerateAgentStateSchema>;
export const isGenerateAgentState = zodTypeguard(GenerateAgentStateSchema);

export const GenerateSegmentsStateSchema = z.object({
  whatISell: z.string(),
  segments: CategorySchema.array(),
  customerBlob: z.string(),
});
export type GenerateSegmentsState = z.infer<typeof GenerateSegmentsStateSchema>;
export const isGenerateSegmentsState = zodTypeguard(
  GenerateSegmentsStateSchema
);

const GenerateCampaignsStateSchema = z.object({
  campaignChatId: ObjectIdSchema,
  campaigns: CampaignSchema.array(),
  responseId: z.string(),
});
export type GenerateCampaignsState = z.infer<
  typeof GenerateCampaignsStateSchema
>;
export const isGenerateCampaignsState = zodTypeguard(
  GenerateCampaignsStateSchema
);
